import "./DrugOrderConfirmLotTable.css";

const DrugOrderConfirmLotTable = ({ data }) => {
  return (
    <div className="drug-order-confirm-lot-table-container">
      <table className="drug-order-confirm-lot-table">
        <thead className="drug-order-confirm-lot-table-header">
          <tr>
            <th className="drug-order-confirm-table-header-name">Lot Name</th>
            <th className="drug-order-confirm-table-header-name">Drug Name</th>
            <th className="drug-order-confirm-table-header-name">Quantity</th>
          </tr>
        </thead>
        <tbody style={{ textAlign: "center" }}>
          {data &&
            data?.map((item, index) => (
              <tr key={index}>
                <td className="drug-order-confirm-table-data">{item.lot}</td>
                <td className="drug-order-confirm-table-data">
                  {item.drugName}
                </td>
                <td className="drug-order-confirm-table-data">
                  {item.quantity}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default DrugOrderConfirmLotTable;
